<style lang="scss">
.single-option-select {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.on-demand-single-option label {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord(params.id)"
    />
    <!--<feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />-->
    
    <feather-icon v-show="params.TypeID && params.TypeID !=4"
      icon="SettingsIcon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="otherSettings(params.id, params.TypeID)"
    />

    <vs-popup class="holamundo other-settings" title="Other Settings" :active.sync="popupOtherSettings">
      <vs-tabs position="left" color="danger" v-if="session_data">
        <vs-tab label="Live Panel / Keynote" v-if="sessionTypeId==3">
          <h4 class="mb-3">Live-Panel Advanced Settings</h4>
          <div class="vx-row">
            <div class="vx-col md:w-1/1 w-full">
              <div class="single-option-select" v-if="session_data.StreamingClient=='Web'">
                <label> Show Group Chat </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.EnableGroupChat">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>

              <div class="mt-4 single-option-select" v-if="session_data.StreamingClient=='Web'">
                <label> Show Attendee List </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.ShowAttendeeList">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>

              <div class="mt-4 single-option-select" v-if="session_data.StreamingClient=='Web'">
                <label> Show Speaker List </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.ShowSpeakerList">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>

              <div class="mt-4 single-option-select" v-if="session_data.StreamingClient=='Web'">
                <label> Audience Poll </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.AudiencePoll">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>

              <!-- <div class="mt-4 single-option-select hidden">
                <label> Show Agenda </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.ShowAgenda">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div> -->

              <div class="mt-4 single-option-select" v-if="session_data.StreamingClient=='Web'">
                <label> Enable Raise Hand </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.EnableRaiseHand">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 single-option-select" v-if="session_data.StreamingClient=='Web'">
                <label> Enable Invite Session Attendee </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.EnableInviteSessionAttendee">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 single-option-select" v-if="session_data.StreamingClient=='Web'">
                <label> Enable Spot Light </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.EnableSpotlight">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/1 w-full">
              <div class="single-option-select mt-4" v-if="session_data.StreamingClient=='Web'">
                <label> Enable Live QnA (Auto publishes Questions) </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.EnableLiveQnA">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 pl-5 single-option-select" v-if="session_data.StreamingClient=='Web'">
                <label> >> Allow posting Questions Anonymously</label>
                <div class="ml-4">
                  <vs-switch
                    v-model="session_data.AllowPostingQuestionsAnonymously"
                    :disabled="!session_data.EnableLiveQnA"
                  >
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 pl-5 single-option-select" v-if="session_data.StreamingClient=='Web'">
                <label>
                  >> Activate Moderation(2 step - Approval & Publish)</label
                >
                <div class="ml-4">
                  <vs-switch
                    v-model="session_data.QnAModeration"
                    :disabled="!session_data.EnableLiveQnA"
                  >
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 pl-5 single-option-select" v-if="session_data.StreamingClient=='Web'">
                <label>
                  >> Activate Moderation(1 step - Approve & Auto-Publish)
                </label>
                <div class="ml-4">
                  <vs-switch
                    v-model="session_data.QnAAutoPublish"
                    :disabled="!session_data.EnableLiveQnA"
                  >
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>

              <!-- <div class="mt-4 single-option-select">
                <label> Enable Help / Settings </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.EnableHelpORSettings">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div> -->
              <div class="mt-4 single-option-select">
                <label> Convert To OnDemand Video On Session End </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.ConvertToOnDemandVideoOnSessionEnd">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>
              <!-- <div class="mt-4 single-option-select" v-if="session_data.IsZoomRTMP">
                <vs-button color="rgb(76, 139, 246)" type="filled" class="sub-btn" v-on:click="enableRTMPMeeting">Start RTMP streaming for Audience view</vs-button>
              </div> -->
            </div>
          </div>
        </vs-tab>
        <vs-tab v-show="PlanDetails.AllowSessionOnDemandVideo" label="On-Demand" v-if="sessionTypeId==1">
          <div class="vx-row">
            <div class="vx-col md:w-1/1 w-full mb-4">
              <h5>Other Settings</h5>
              <hr />              
              <ul>
                <li>
                  <div class="on-demand-single-option mt-4">
                    <label
                      ><span class="mr-2">Show Player Controls</span>
                      <vs-switch
                        v-model="session_data.PlayerControl"
                      ></vs-switch
                    ></label>
                  </div>
                </li>
                <li>
                  <div class="on-demand-single-option mt-4">
                    <label
                      ><span class="mr-2">Enable Group Chat</span>
                      <vs-switch
                        v-model="session_data.EnableGroupChat"
                      ></vs-switch
                    ></label>
                  </div>
                </li>
                <li>
                  <div class="on-demand-single-option mt-4">
                    <label
                      ><span class="mr-2">Show Attendee List</span>
                      <vs-switch
                        v-model="session_data.ShowAttendeeList"
                      ></vs-switch
                    ></label>
                  </div>
                </li>
                <li>
                    <div class="on-demand-single-option mt-4">
                      <label><span class="mr-2"> Show Speaker List </span>                      
                        <vs-switch v-model="session_data.ShowSpeakerList">                          
                        </vs-switch>
                      </label>                      
                    </div>
                  </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/1 w-full">
              <div class="single-option-select">
                <label> Enable Live QnA (Auto publishes Questions) </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.EnableLiveQnA">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 pl-5 single-option-select">
                <label> >> Allow posting Questions Anonymously</label>
                <div class="ml-4">
                  <vs-switch
                    v-model="session_data.AllowPostingQuestionsAnonymously"
                    :disabled="!session_data.EnableLiveQnA"
                  >
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 pl-5 single-option-select">
                <label>
                  >> Activate Moderation(2 step - Approval & Publish)</label
                >
                <div class="ml-4">
                  <vs-switch
                    v-model="session_data.QnAModeration"
                    :disabled="!session_data.EnableLiveQnA"
                  >
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 pl-5 single-option-select">
                <label>
                  >> Activate Moderation(1 step - Approve & Auto-Publish)
                </label>
                <div class="ml-4">
                  <vs-switch
                    v-model="session_data.QnAAutoPublish"
                    :disabled="!session_data.EnableLiveQnA"
                  >
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-12/12 w-full mt-4">
                <div class="single-option-select">
                  <label>Enable Bottom Bar</label>
                  <vs-switch
                    v-model="session_data.EnableBottomBar"
                    class="ml-5"
                  />
                </div>
                <div
                  class="mt-4 photo-album-selection"
                  v-show="session_data.EnableBottomBar"
                >
                  <label>Select Photo Album</label>
                  <div class="select-album">
                    <v-select
                      class="track-select"
                      name="photoDirectory"
                      label="photoDirectory"
                      v-model="session_data.PhotoWallAlbum"
                      :options="PhotoWallAlbumList"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                  </div>
                </div>
                <div
                  class="mt-4 embed-code-space"
                  v-show="session_data.EnableBottomBar"
                >
                  <label>Embed Code</label>
                  <vs-textarea v-model="session_data.EmbedCode" />
                </div>
                <div
                  class="mt-4 embed-code-space"
                  v-show="session_data.EnableBottomBar"
                >
                  <label>Display</label>
                  <ul class="centerx">
                    <li>
                      <vs-radio
                        v-model="session_data.Active"
                        vs-value="PhotoWallAlbum"
                        >Photo Wall Album</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio                        
                        v-model="session_data.Active"
                        vs-value="EmbedCode"
                        >Embed Code</vs-radio
                      >
                    </li>
                  </ul>
                </div>
            </div>
          </div>
        </vs-tab>
        <vs-tab v-show="PlanDetails.AllowSessionLiveSimulated" label="Live Stream" v-if="sessionTypeId==2">
          <div class="live-stream-inner-wrapper">
           <div class="vx-row">
              <div class="vx-col md:w-1/1 w-full mb-4">
                <h5>Other Settings</h5>
                <hr />                
                <ul>
                  <li>
                    <div class="on-demand-single-option mt-4">
                      <label
                        ><span class="mr-2">Show Player Controls</span>
                        <vs-switch
                          v-model="session_data.PlayerControl"
                        ></vs-switch
                      ></label>
                    </div>
                  </li>
                  <li>
                    <div class="on-demand-single-option mt-4">
                      <label
                        ><span class="mr-2">Enable Group Chat</span>
                        <vs-switch
                          v-model="session_data.EnableGroupChat"
                        ></vs-switch
                      ></label>
                    </div>
                  </li>
                  <li>
                    <div class="on-demand-single-option mt-4">
                      <label
                        ><span class="mr-2">Show Attendee List</span>
                        <vs-switch
                          v-model="session_data.ShowAttendeeList"
                        ></vs-switch
                      ></label>
                    </div>
                  </li>
                  <li>
                    <div class="on-demand-single-option mt-4">
                      <label><span class="mr-2"> Show Speaker List </span>                      
                        <vs-switch v-model="session_data.ShowSpeakerList">                          
                        </vs-switch>
                      </label>                      
                    </div>
                  </li>
                </ul>
              </div>
              <div class="vx-col md:w-1/1 w-full">
                <div class="single-option-select">
                  <label> Enable Live QnA (Auto publishes Questions) </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.EnableLiveQnA">
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 pl-5 single-option-select">
                  <label> >> Allow posting Questions Anonymously</label>
                  <div class="ml-4">
                    <vs-switch
                      v-model="session_data.AllowPostingQuestionsAnonymously"
                      :disabled="!session_data.EnableLiveQnA"
                    >
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 pl-5 single-option-select">
                  <label>
                    >> Activate Moderation(2 step - Approval & Publish)</label
                  >
                  <div class="ml-4">
                    <vs-switch
                      v-model="session_data.QnAModeration"
                      :disabled="!session_data.EnableLiveQnA"
                    >
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 pl-5 single-option-select">
                  <label>
                    >> Activate Moderation(1 step - Approve & Auto-Publish)
                  </label>
                  <div class="ml-4">
                    <vs-switch
                      v-model="session_data.QnAAutoPublish"
                      :disabled="!session_data.EnableLiveQnA"
                    >
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-12/12 w-full mt-4">
                  <div class="single-option-select">
                    <label>Enable Bottom Bar</label>
                    <vs-switch
                      v-model="session_data.EnableBottomBar"
                      class="ml-5"
                    />
                  </div>
                  <div
                    class="mt-4 photo-album-selection"
                    v-show="session_data.EnableBottomBar"
                  >
                    <label>Select Photo Album</label>
                    <div class="select-album">
                      <v-select
                        class="track-select"
                        name="photoDirectory"
                        label="photoDirectory"
                        v-model="session_data.PhotoWallAlbum"
                        :options="PhotoWallAlbumList"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      />
                    </div>
                  </div>
                  <div
                    class="mt-4 embed-code-space"
                    v-show="session_data.EnableBottomBar"
                  >
                    <label>Embed Code</label>
                    <vs-textarea v-model="session_data.EmbedCode" />
                  </div>
                  <div
                    class="mt-4 embed-code-space"
                    v-show="session_data.EnableBottomBar"
                  >
                    <label>Display</label>
                    <ul class="centerx">
                      <li>
                        <vs-radio
                          v-model="session_data.Active"
                          vs-value="PhotoWallAlbum"
                          >Photo Wall Album</vs-radio
                        >
                      </li>
                      <li>
                        <vs-radio
                          v-model="session_data.Active"
                          vs-value="EmbedCode"
                          >Embed Code</vs-radio
                        >
                      </li>
                    </ul>
                  </div>
              </div>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Custom Url" v-if="sessionTypeId==5">
          <div class="row">
            <div class="vx-col md:w-1/1 w-full">
              <h5>Other Settings</h5>
              <hr />
              <div class="single-option-select">
                <label> Show Group Chat </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.EnableGroupChat">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>

              <div class="mt-4 single-option-select">
                <label> Audience Poll </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.AudiencePoll">
                    </vs-switch>
                  </div>
              </div>

              <div class="mt-4 single-option-select hidden">
                <label> Show Attendee List </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.ShowAttendeeList">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>

              <div class="mt-4 single-option-select">
                <label> Enable Live QnA (Auto publishes Questions) </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.EnableLiveQnA">
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 pl-5 single-option-select">
                <label> >> Allow posting Questions Anonymously</label>
                <div class="ml-4">
                  <vs-switch
                    v-model="session_data.AllowPostingQuestionsAnonymously"
                    :disabled="!session_data.EnableLiveQnA"
                  >
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 pl-5 single-option-select">
                <label>
                  >> Activate Moderation(2 step - Approval & Publish)</label
                >
                <div class="ml-4">
                  <vs-switch
                    v-model="session_data.QnAModeration"
                    :disabled="!session_data.EnableLiveQnA"
                  >
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 pl-5 single-option-select">
                <label>
                  >> Activate Moderation(1 step - Approve & Auto-Publish)
                </label>
                <div class="ml-4">
                  <vs-switch
                    v-model="session_data.QnAAutoPublish"
                    :disabled="!session_data.EnableLiveQnA"
                  >
                  </vs-switch>
                </div>
              </div>

              <div class="mt-4 single-option-select hidden">
                <label> Show Speaker List </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.ShowSpeakerList">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>

              <div class="mt-4 single-option-select hidden">
                <label> Show Agenda </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.ShowAgenda">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>

              <div class="mt-4 single-option-select hidden">
                <label> Enable Raise Hand </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.EnableRaiseHand">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="In Person" v-if="sessionTypeId==6">
          <div class="row">
            <div class="vx-col md:w-1/1 w-full">
              <h5>Other Settings</h5>
              <hr />
              <div class="single-option-select">
                <label> Show Group Chat </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.EnableGroupChat">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>

              <div class="mt-4 single-option-select">
                <label> Audience Poll </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.AudiencePoll">
                    </vs-switch>
                  </div>
              </div>

              <div class="mt-4 single-option-select">
                <label> Enable Live QnA (Auto publishes Questions) </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.EnableLiveQnA">
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 pl-5 single-option-select">
                <label> >> Allow posting Questions Anonymously</label>
                <div class="ml-4">
                  <vs-switch
                    v-model="session_data.AllowPostingQuestionsAnonymously"
                    :disabled="!session_data.EnableLiveQnA"
                  >
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 pl-5 single-option-select">
                <label>
                  >> Activate Moderation(2 step - Approval & Publish)</label
                >
                <div class="ml-4">
                  <vs-switch
                    v-model="session_data.QnAModeration"
                    :disabled="!session_data.EnableLiveQnA"
                  >
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 pl-5 single-option-select">
                <label>
                  >> Activate Moderation(1 step - Approve & Auto-Publish)
                </label>
                <div class="ml-4">
                  <vs-switch
                    v-model="session_data.QnAAutoPublish"
                    :disabled="!session_data.EnableLiveQnA"
                  >
                  </vs-switch>
                </div>
              </div>
              
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <div class="mt-8 flex flex-wrap items-center justify-center">
        <vs-button color="rgb(76, 139, 246)" type="filled" class="sub-btn" v-on:click="formSubmitted">Submit</vs-button>
      </div>
    </vs-popup>
  </div>

  

</template>

<script>
import vSelect from "vue-select";

import moduleSessionManagement from "@/store/session-management/moduleSessionManagement.js";
import moduleClientManagement from "@/store/client-management/moduleClientManagement.js";
import modulePhotoWall from "@/store/photowall-management/modulePhotowallManagement.js";
import ls from "@/common/localStorage";

let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
let Session_EventStartDate = ls.getSessionValueByKey("Session_EventStartDate");
let Session_EventEndDate = ls.getSessionValueByKey("Session_EventEndDate");
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
export default {
  name: "CellRendererActions",
  components: {
    "v-select": vSelect,
  },
  data(){
    return {
      popupOtherSettings: false,
      session_data: null,
      PhotoWallAlbumList: [],
      PlanDetails: null,
      sessionTypeId: null,
      sessionId: null,
      slectedTab: 0
    }
  },
  watch: {
    "session_data.EnableLiveQnA"(val) {
      this.session_data.QnAModeration = this.session_data.EnableLiveQnA
        ? this.session_data.QnAModeration
        : false;
      this.session_data.QnAAutoPublish = this.session_data.EnableLiveQnA
        ? this.session_data.QnAAutoPublish
        : false;
      this.session_data.AllowPostingQuestionsAnonymously = this.session_data.EnableLiveQnA
        ? this.session_data.AllowPostingQuestionsAnonymously
        : false;
    },
    "session_data.QnAModeration"(val) {
      this.session_data.QnAAutoPublish = val
        ? false
        : this.session_data.QnAAutoPublish;
    },
    "session_data.QnAAutoPublish"(val) {
      this.session_data.QnAModeration = val
        ? false
        : this.session_data.QnAModeration;
    }
  },
  methods: {
    enableRTMPMeeting(){
      this.$vs.loading();
      this.$store.dispatch("sessionManagement/enableZoomRTMPmeeting", this.session_data)
        .then((res) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: res.code == 1 ? "success" : "warning",
            position: "top-center",
            text: res.code == 1 ? "RTMP Enabled." : "Meeting not started!",
          });
        })
        .catch((err) => {
          console.error(err);
          this.$vs.loading.close();
        });
    },
    fetch_photowallAlbum() {
      this.$store
        .dispatch("photowallManagement/fetchPhotowallAlbum") //fetchphotowallAlbum
        .then((res) => {
          this.PhotoWallAlbumList = res;
        });
    },
    fetchClientPlanDetails() {
      this.$store
        .dispatch("clientManagement/fetchClientPlanDetails", Session_Client_Id)
        .then((res) => {
          if (res.PlanDetails) {
            this.PlanDetails = res.PlanDetails;
          }
        });
    },
    otherSettings(sesionId, sessionTypeId){
      this.$vs.loading();
      this.$store
        .dispatch("sessionManagement/fetchSession", sesionId)
        .then((res) => {
          this.sessionTypeId = sessionTypeId
          this.sessionId = sesionId
          this.session_data = res.data;
          console.log(this.session_data.PlayerControl)
          if (res.data.SessionTypeDetails.TypeID == 1) {
            this.slectedTab = 1;
          } else if (res.data.SessionTypeDetails.TypeID == 2) {
            this.slectedTab = 2;
          } else if (res.data.SessionTypeDetails.TypeID == 3) {
            this.slectedTab = 0;
          } else if (res.data.SessionTypeDetails.TypeID == 4) {
            this.slectedTab = 3;
          } else if (res.data.SessionTypeDetails.TypeID == 5) {
            this.slectedTab = 4;
          } else if (res.data.SessionTypeDetails.TypeID == 6) {
            this.slectedTab = 5;
          }
          this.$vs.loading.close();
          this.popupOtherSettings = true
        })
      
    },
    editRecord(id) {
      //console.log(id);
      //id = window.btoa(id);
      this.$router
        .push({
          name: "session-edit",
          params: {
            sessionId: id
          }
        })
        .catch(() => {});

      /*
              Below line will be for actual product
              Currently it's commented due to demo purpose - Above url is for demo purpose

              this.$router.push("/apps/user/user-edit/" + this.params.data.id).catch(() => {})
            */
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete "${this.params.data.username}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      this.showDeleteSuccess();

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "User Deleted",
        text: "The selected user was successfully deleted"
      });
    },    
    formSubmitted() {
      this.$vs.loading();
      let ID = this.sessionId;   
      let TypeID = this.sessionTypeId   
      console.log(this.session_data.EnableBottomBar)
      this.$store
        .dispatch("sessionManagement/updateOtherSettings", {
          id: ID,
          data: this.session_data,
          TypeID: TypeID,
        })
        .then((res) => {
          this.$vs.loading.close();
          if (res.status == 200) {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Session",
              text: "Session updated successfully.",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
        });
    },
  },
  created(){
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
    this.fetchClientPlanDetails();
    if (!moduleSessionManagement.isRegistered) {
      this.$store.registerModule("sessionManagement", moduleSessionManagement);
      moduleSessionManagement.isRegistered = true;
    }
    if (!modulePhotoWall.isRegistered) {
      this.$store.registerModule("photowallManagement", modulePhotoWall);
      modulePhotoWall.isRegistered = true;
    }
    this.fetch_photowallAlbum();
    
  }
};
</script>
